<template>
    <div class="use-help">
        <img src="../../.././assets/images/normal/header.jpg" alt="" />
        <img src="../../.././assets/images/normal/step1.jpg" alt="" />
        <div class="copy-box">
            <img src="../../.././assets/images/normal/step2.jpg" alt="" />
            <a href="javascript:void(0)" id="copy-btn" @click="copy">复制打款信息</a>
        </div>
        <img src="../../.././assets/images/normal/step3.jpg" alt="" />
        <!-- <div class="exclusive-enjoy">
            <button class="bigBtn">点我去充值</button>
        </div> -->
        <div class="charge-box">
            <button class="bigBtn default-button" id="charge-btn" @click="largePayment">点我去充值</button>
        </div>
    </div>
</template>
<script>
import {
    callHandler
} from "../../../utils/bridge";
export default {
    data( ) {
        return {};
    },

    methods: {
        copy( ) {
            callHandler( "xhOpenAppPasteboard", {
                content: "收款银行：广发银行广州分行营业部 " + "账户名称：恒诚科技发展（北京）有限公司客户转账交易资金存管账户 " + "账户账号：9550880055238200491"
            } );
            this.$toast( "已复制到剪切板" );
        },
        largePayment( ) {
            callHandler( "xhWapGoBack", "wapCloseWeb" );
        }
    }
};
</script>
<style lang="less">
.use-help {
    line-height: 0;
    font-size: 0;
    vertical-align: bottom;
    padding-bottom: 120px;
    background: #4b5a79;
    max-width: 750px;
    margin: 0 auto;

    .copy-box {
        position: relative;

        a {
            display: block;
            height: 8.1%;
            width: 68.8%;
            bottom: 11.6%;
            left: 15.6%;
            cursor: pointer;
            position: absolute;
            text-indent: -9999px;
        }
    }

    img {
        width: 100%;
        display: block;
        vertical-align: bottom;
        border: none;
    }

    .charge-box {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(21, 29, 42, 0.6);
        padding: 8px 0 6px;

        a {
            color: #fff;
            font-size: 16px;
        }
    }

    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        body {
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
        }
    }
}
</style>
